// extracted by mini-css-extract-plugin
module.exports = {"block-wrapper":"_3Knwl","paywall-img":"_27UHn","popup-div":"BgsOr","popup-main-div":"_1uSEV","helper-text":"_1MPgS","pay-btn":"_3TpJF"};